import ajax from "@/utils/request";

/********* 登录 **********/
export const loginAPI = (data) => ajax('/api/login/', data, 'POST');
// ldap登录
export const ldapLogin = (data) => ajax('/api/authSrc/ldapLogin', data, 'POST');
// 手机验证码登录
export const phoneLogin = (data) => ajax('/api/login/phoneLogin', data, 'POST');
// 邮箱验证码登录
export const emailLogin = (data) => ajax('/api/login/emailLogin', data, 'POST');
// 获取应用信息
export const getLoginApp = (data) => ajax('/api/login/getLoginApp', data, 'POST');
// 重置密码
export const resetPwd = (data) => ajax('/api/login/resetPwd', data, 'POST');
// 发送短信重置密码、验证码登录
// export const sendPhoneCode = (data) => ajax('/api/login/sendPhoneCode', data, 'POST');
// 修改密码
export const updatePwd = (data) => ajax('/api/login/updatePwd', data, 'POST');
// 获取验证码
export const getVerifyCode = (data) => ajax('/api/login/getVerifyCode', data, 'GET');
// 第三方登录
export const authorize = (data) => ajax('/api/authSrc/authorize', data, 'POST');
// 第三方绑定
export const authBind = (data) => ajax('/api/authSrc/bind', data, 'POST');
// 第三方登录成功后调用
export const authLogin = (data) => ajax('/api/authSrc/login/',data, 'POST');
// 退出登录
export const logout = (data) => ajax('/api/login/logout', data, 'GET');

// 推送otp
export const pushOtp = (data) => ajax('/api/login/pushOtp', data, 'POST');
// 校验otp
export const checkOtp = (data) => ajax('/api/login/checkOtp', data, 'POST');
// 临时认证校验
export const tempLogin = (data) => ajax('/api/login/tempLogin', data, 'POST');

// 登录推送uaf
export const pushUaf = (data) => ajax('/api/login/pushUaf', data, 'POST');


// 进入到登录页面，检查登录状态的接口
export const getLoginStatus = (data) => ajax('/api/login/getLoginStatus', data, 'POST');

// 调起u2f
export const fido2AuthStart = (data) => ajax('/api/login/fido2AuthStart', data, 'POST');
// u2f登录
export const fido2AuthConfirm = (data) => ajax('/api/login/fido2AuthConfirm', data, 'POST');

/************ 应用 *********/
// 应用列表
export const accessList = (data) => ajax('/api/application/accessList', data, 'GET');
// 跳转
export const signOn = (data) => ajax('/api/application/signOn/' + data, '', 'GET');

//验证多因素列表
export const checkMfa = (data) => ajax('/api/application/checkMfa/' + data, '', 'GET');

//重置用户登录状态
export const refreshSession = (data) => ajax('/api/login/refreshSession', data, 'GET');
// 获取企业图片新闻
export const getImageNews = (data) => ajax('/api/notice/getImageNews', data,'POST');
// 获取企业普通新闻
export const getNormalNews = (data) => ajax('/api/notice/getNormalNews',data,  'POST');


/*********** 个人资料 ************/
// 获取个人资料
export const userAPI = (data) => ajax('/api/v1/user', data, 'GET');
// 获取个人属性
export const userAttr = (data) => ajax('/api/v1/user/attr', data, 'GET');
// 修改用户
export const editUser = (data) => ajax('/api/v1/user', data, 'POST');
// 获取个人头像
export const userPhoto = (data) => ajax('/api/v1/user/photo', data, 'GET');
// 减绑用户社交认证
export const userUnbind = (data) => ajax('/api/v1/user/unbind', data, 'POST');
// 获取用户社交认证信息
export const userSocials = (data) => ajax('/api/v1/user/socials', data, 'GET');
// 上传头像
export const userUpload = (data) => ajax('/api/v1/user/upload', data, 'POST');


// 操作记录
export const logList = (data) => ajax('/api/v1/log/list', data, 'GET');


/******** 个人偏好 *******/

// 常用应用
export const reportApp = (data) => ajax('/api/v1/report/app', data, 'GET');
// 常用认证方式
export const reportAuth = (data) => ajax('/api/v1/report/auth', data, 'GET');
// 常用设备
export const reportDevice = (data) => ajax('/api/v1/report/device', data, 'GET');
// 常用时段分布
export const reportAuthTime = (data) => ajax('/api/v1/report/authTime', data, 'GET');
// 常用位置
export const reportLocation = (data) => ajax('/api/v1/report/location', data, 'GET');
// 认证失败原因
export const reportFailure = (data) => ajax('/api/v1/report/failure', data, 'GET');


/******** 账号安全 *******/

// 获取用户账号安全
export const getUserAccountSecurity = (data) => ajax('/api/v1/safe/getUserAccountSecurity', data, 'GET');
// 修改用户密码
export const resetUserPwd = (data) => ajax('/api/v1/safe/resetUserPwd', data, 'POST');
// 设置用户密码
export const setUserPwd = (data) => ajax('/api/v1/safe/setUserPwd', data, 'POST');
// 修改手机
export const updatePhone = (data) => ajax('/api/v1/safe/updatePhone', data, 'POST');
// 绑定手机
export const bindPhone = (data) => ajax('/api/v1/safe/bindPhone', data, 'POST');
// 修改绑定邮箱
export const updateEmail = (data) => ajax('/api/v1/safe/updateEmail', data, 'POST');
// 绑定邮箱
export const bindEmail = (data) => ajax('/api/v1/safe/bindEmail', data, 'POST');
// 发送邮件
export const sendEmail = (data) => ajax('/api/v1/send/email', data, 'POST');
// 发送短信
export const sendSms = (data) => ajax('/api/v1/send/sms', data, 'POST');
// 验证手机令牌
export const checkMobileToken = (data) => ajax('/api/v1/safe/checkMobileToken', data, 'POST');
// 获取手机令牌二维码
export const getMobileTokenActiveData = (data) => ajax('/api/v1/safe/getMobileTokenActiveData', data, 'GET');
// 获取用户令牌激活状态
export const getUserActivationStatus = (data) => ajax('/api/v1/safe/getUserActivationStatus', data, 'GET');
// 获取UAF令牌二维码
export const getUAFTokenActiveQrcode = (data) => ajax('/api/v1/safe/getUAFTokenActiveQrcode', data, 'GET');
// 获取多因素配置列表
export const getMfa = (data) => ajax('/api/v1/user/getMfa', data, 'GET');
// 修改多因素配置列表
export const updateMfa = (data) => ajax('/api/v1/user/updateMfa', data, 'POST');
// 重置动态口令
export const resetMobileToken = (data) => ajax('/api/v1/safe/resetMobileToken', data, 'POST');
// 推送手机令牌
// export const pushMobileToken = (data) => ajax('/api/v1/safe/pushMobileToken', data, 'POST');
// 获取推送结果
// export const getPushResult = (data) => ajax('/api/v1/safe/getPushResult', data, 'GET');
// 获取密码规则
export const getPwdRule = (data) => ajax('/api/v1/safe/getPwdRule', data, 'GET');
export const getNotLoginPwdRule = (data) => ajax('/api/v1/safe/getNotLoginPwdRule', data, 'POST');
// 推送UAF令牌
// export const pushUAFToken = (data) => ajax('/api/v1/safe/pushUAFToken', data, 'POST');
// 激活uaf令牌 - 记录日志
export const activationUAFToken = (data) => ajax('/api/v1/safe/activationUAFToken', data, 'POST');
// 重置UAF令牌
export const resetUAFToken = (data) => ajax('/api/v1/safe/resetUAFToken', data, 'POST');

// 绑定OTP硬件令牌
export const bindHardwareToken = (data) => ajax('/api/v1/safe/bindHardwareToken', data, 'POST');
// 解绑OTP硬件令牌
export const unbindHardwareToken = (data) => ajax('/api/v1/safe/unbindHardwareToken', data, 'POST');
// 获取硬件令牌列表
export const getHardwareToken = (data) => ajax('/api/v1/safe/getHardwareToken', data, 'GET');
// 二维码下载地址
export const codeDownload = (data) => ajax('/api/v1/safe/download', data, 'GET');


// 发送短信,带验证密码
export const checkPwd = (data) => ajax('/api/v1/send/sms/checkPwd', data, 'POST');

// 重置短信,不需要手机号
export const smsReset = (data) => ajax('/api/v1/send/sms/reset', data, 'POST');
// 发送邮箱,带验证密码
export const emailCheckPwd = (data) => ajax('/api/v1/send/email/checkPwd', data, 'POST');

// 获取FIDO U2F硬件令牌
export const u2fRegisterStart = (data) => ajax('/api/v1/safe/u2fRegisterStart', data, 'POST');
// 校验FIDO U2F硬件令牌
export const u2fRegisterConfirm = (data) => ajax('/api/v1/safe/u2fRegisterConfirm', data, 'POST');
// 解绑FIDO U2F硬件令牌
export const u2fUnbind = (data) => ajax('/api/v1/safe/u2fUnbind', data, 'POST');
// 获取FIDO u2f硬件令牌列表
export const getU2fToken = (data) => ajax('/api/v1/safe/getU2fToken', data, 'GET');
// 获取webAuthn注册
export const webAuthnRegisterStart = (data) => ajax('/api/v1/safe/u2fWindowsRegisterStart', data, 'POST');
// 获取webAuthn确认
export const webAuthnRegisterConfirm = (data) => ajax('/api/v1/safe/u2fWindowsRegisterConfirm', data, 'POST');


// 获取获取已绑定windows hello 令牌
export const reqGetU2fWindowsToken = (data) => ajax('/api/v1/safe/getU2fWindowsToken', data, 'GET');
// 解绑windows hello 令牌
export const reqU2fWindowsUnbind = (data) => ajax('/api/v1/safe/u2fWindowsUnbind', data, 'POST');

/*********** 图形验证码 ************/

export const reqGet = (data) => ajax('/api/login/getCaptcha', data, 'POST');
export const reqCheck = (data) => ajax('/api/login/checkCaptcha', data, 'POST');


// 获取加密公钥
export const getRsaPubKey = (data) => ajax('/api/config/getRsaPubKey', data, 'GET');

/****** 通知 ****/

// 列表
export const noticeList = (data) => ajax('/api/notice/list', data, 'POST');

// 详情
export const noticeDetail = (data) => ajax('/api/notice/detail', data, 'POST');

// 未拉取列表
export const noPullList = (data) => ajax('/api/notice/noPullList', data, 'POST');

// 批量已读
export const noticeRead = (data) => ajax('/api/notice/read', data, 'POST');


/** 登录操作 */
//验证嚣接口
export const reqGetAuthenticators = (data) => ajax('/api/login/getAuthenticators', data, 'POST');

//密码登录
export const reqLoginPwd = (data) => ajax('/api/login/pwdLogin', data, 'POST');

//fastPass 有用户名认证时的认证
 export const reqFastLoginStart = (data) => ajax('/api/login/fastLogin/start', data, 'POST');
 export const reqFastLogin = (data) => ajax('/api/login/fastLogin', data, 'POST');

 //二维码登录




export const reqCheckFence = (data) => ajax('/api/login/checkFence', data, 'POST');
//面板多因素认证 --start

// 推送otp
export const pushCheckMfaOtp = (data) => ajax('/api/application/checkMfa/pushOtp', data, 'POST');
// 校验otp
export const checkCheckMfaOtp = (data) => ajax('/api/application/checkMfa/checkOtp', data, 'POST');
// 临时认证校验
export const tempCheckMfaLogin = (data) => ajax('/api/application/checkMfa/tempLogin', data, 'POST');

// 登录推送uaf
export const pushCheckMfaUaf = (data) => ajax('/api/application/checkMfa/pushUaf', data, 'POST');


// 手机验证码登录
export const phoneCheckMfaCode = (data) => ajax('/api/application/checkMfa/checkPhoneCode', data, 'POST');
// 邮箱验证码登录
export const emailCheckMfaCode = (data) => ajax('/api/application/checkMfa/checkEmailCode', data, 'POST');

//密码登录
export const loginCheckMfaPwd = (data) => ajax('/api/application/checkMfa/checkPwd', data, 'POST');

//ldap windows ad
export const authSrcCheckMfaLdapLogin = (data) => ajax('/api/application/checkMfa/authSrc/ldapLogin', data, 'POST');



//获取扫码登录二维码
export const reGetQrcode = (data) => ajax('/api/login/getQrcode', data, 'GET');
// 扫码登录二维码登录校验
export const reqScanLogin = (data) => ajax('/api/login/scanLogin', data, 'POST');

// check maf 扫码登录二维码登录校验
export const reqCheckMfaScanLogin = (data) => ajax('/api/application/checkMfa/scanLogin', data, 'POST');


// 获取登录验证码
//export const getQrcode = (data) => ajax('/api/application/checkMfa/getQrcode', data, 'GET');
// 验证码登录校验
export const scanCheckMfaLogin = (data) => ajax('/api/application/checkMfa/scanLogin', data, 'POST');

// 调起Fast
export const reqCheckMfaStartFastLogin = (data) => ajax('/api/application/checkMfa/startFastLogin', data, 'POST');
export const reqCheckMfaFastLogin = (data) => ajax('/api/application/checkMfa/fastLogin', data, 'POST');

// 调起u2f
export const fido2CheckMfaAuthStart = (data) => ajax('/api/application/checkMfa/fido2AuthStart', data, 'POST');
// u2f登录
export const fido2CheckMfaAuthConfirm = (data) => ajax('/api/application/checkMfa/fido2AuthConfirm', data, 'POST');

//刷新围栏二维码

export const reqRefreshLocationQrCode = (data) => ajax('/api/login/refreshLocationQrCode', data, 'POST');



//电子围栏认证
export const reqCheckMfaFence = (data) => ajax('/api/application/checkMfa/checkFence', data, 'POST');

export const reqCheckMfaRefreshLocationQrCode = (data) => ajax('/api/application/checkMfa/refreshLocationQrCode', data, 'POST');






//面板多因素认证 --end
/** 水印    */
//获取水印接口
export const reqGetWaterConf = (data) => ajax('/api/login/getWatermarkConf', data, 'GET');


/**委托授权* */
export const reqGetApplicationList = (data) => ajax('/api/application/entrustList',data,'GET')
export const reqGetCurUserEntrustApplicationList = (data) => ajax('/api/accountEntrust/getCurUserEntrustApplication ',data,'GET')
export const reqGetAccountEntrustList = (data) => ajax('/api/accountEntrust/list ',data,'POST')
export const reqGetAccountEntrustAdd = (data) => ajax('/api/accountEntrust/add ',data,'POST')
export const reqGetAccountEntrustUpdate = (data) => ajax('/api/accountEntrust/update ',data,'POST')
export const reqGetAccountEntrustDelete = (data) => ajax('/api/accountEntrust/del ',data,'POST')
export const reqGetUserByUserName = (data) => ajax('/api/v1/user/getUserByUsername',data,'POST')
export const reqGetEntrustmentRecord = (data) => ajax('/api/accountEntrust/getEntrustmentRecord',data,'POST')

//sap gui type = 64
export const reqGetAppSapGuiInfo = (data) => ajax('/api/application/getSapInfo/'+data.appKey+ (data.subUsername?`/${data.subUsername}`:''),'','GET')


//c/s表单 protocolType 64
export const reqGetCsFormInfo = (data) => ajax('/api/application/getCsFormInfo/'+data.appKey+ (data.subUsername?`/${data.subUsername}`:''),'','GET')



//待办消息


export const reqGetAllApplicationToDoCount = (data)=>ajax('/api/messageToDo/getAllApplicationToDoCount',data,'POST') //获取应用消息待办数量
export const reqGetToDoViewCount = (data)=>ajax('/api/messageToDo/getToDoViewCount',data,'POST') //获取应用消息待办数量总数
export const reqGetToDoViewList = (data)=>ajax('/api/messageToDo/getToDoViewList',data,'POST')


// 获取可申请访问权限的无直接权限的应用
export const reqGetPermissionApp = (data) => ajax('/api/application/getPermissionApplicationApp',data,'GET')
// 申请应用权限
export const reqAppApply = (data)=>ajax('/api/application/apply',data,'POST')




//rsa公钥，环境，ip模式
export const reqGetCommonConfig = (data)=>ajax('/api/config/getCommonConfig',data,'GET')

//添加分类
export const reqAddProductGroup = (data)=>ajax('/api/applyInductiveSorting/add',data,'POST')
//组应用列表
export const reqGetProductGroupApps = (data)=>ajax('/api/applyInductiveSorting/queryGroupApps',data,'POST')
//获取所有的组
export const reqGetAllProductGroup = (data)=>ajax('/api/applyInductiveSorting/queryAllGroup',data,'GET')
//组排序
export const reqUpdateGroupAppSort = (data)=>ajax('/api/applyInductiveSorting/updAppSort',data,'POST')

//为分类增app

export const reqUpdateGroupApp = (data)=>ajax('/api/applyInductiveSorting/updAppGroup',data,'POST')
//修改
export const reqUpdGroupName = (data)=>ajax('/api/applyInductiveSorting/updGroupName',data,'POST')
//删除
export const reqDelGroup = (data)=>ajax('/api/applyInductiveSorting/delGroup',data,'POST')



//夸浏览器登录配置
export const reqCrossBrowserCommand = (data)=>ajax('/api/application/crossBrowserCommand',data,'POST')
//登录认证
export const reqCrossBrowserLogin = (data)=>ajax('/api/login/crossBrowserLogin',data,'POST')


// 获取主题风格
export const getTheme = (data)=>ajax('/api/v1/user/getTheme',data,'GET')
// 设置主题风格
export const updateTheme = (data)=>ajax('/api/v1/user/updateTheme',data,'POST')


// 第三方应用重写向 /authSrc/authorize
export const redirectAuthSrcAuthorize = (data)=>ajax('/api/authSrc/authorize',data,'POST')
